import { Fade } from 'react-reveal';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import './IntroSection.css';

const IntroSection = () => {
  return (
    <div className='introsection-container'>
      <div className='introsection'>
        <div className='introsection-left'>
          <Fade bottom delay={250}>
            {' '}
            <h1> Accept and verify bank transfers in less than a minute</h1>
          </Fade>
          <Fade bottom delay={500}>
            <p>
              Qevolt helps your offline business incorporate bank transfers as a
              secure payment method.
            </p>
          </Fade>
          <Fade bottom delay={750}>
            <a
              href='https://app.qevolt.com/account/signup'
              target='_blank'
              className='button-anim'
            >
              Get started for free
            </a>
          </Fade>
          <Fade bottom delay={1000}>
            <p className='introsection-banking'>
              Banking services by
              <img src='./assets/kudaLogo.svg' alt='' />
            </p>
          </Fade>
        </div>
        <div className='introsection-right'>
          <img
            className='cutHeroImage'
            src='/assets/dashboard.svg'
            alt=''
            loading='lazy'
          />
          <img
            className='fullHeroImage'
            src='/assets/full-intro.png'
            alt=''
            loading='lazy'
          />
        </div>
      </div>
    </div>
  );
};

export default IntroSection;
